<header class="pageHeader">
    <mat-icon class="mat-icon-md" style="display: inline-block;" aria-hidden="true">{{icon}}</mat-icon>
    <h3>{{ getTitle() }}</h3>
</header>
